import React, { useState } from 'react';
import PropTypes from 'prop-types';
import TeamCard from './TeamCard';
import TeamRuntimeModal from './TeamRuntimeModal';
import ToggleButton from './ToggleButton';
import ActionButton from './ActionButton';

// Блок «Команды»: горизонтальный ряд карточек + таймер/следующая.
export default function TeamsColumn({ session, democracy, dispatch }) {
    const flags = session.flags || {};
    const teams = [...(session.teams || [])].sort((a, b) => a.orderId - b.orderId);
    const [selectedTeam, setSelectedTeam] = useState(null);

    return (
        <div className="ctrl-col teams-col">
            <h4>Команды</h4>
            <div className="teams-row">
                {teams.map(team => (
                    <TeamCard
                        key={team.teamId || team.id}
                        team={team}
                        democracyId={democracy.id}
                        currentTeamOrderId={session.currentTeamOrderId}
                        onSelect={() => dispatch.selectTeam(team.orderId)}
                        onEdit={setSelectedTeam}
                    />
                ))}
            </div>
            <div className="teams-acts">
                <ToggleButton
                    on={!!flags.timeIsActive}
                    onLabel="Остановить таймер"
                    offLabel="Запустить таймер"
                    onClick={() => (flags.timeIsActive ? dispatch.pauseTimer() : dispatch.startTimer())}
                />
                <ActionButton label="К следующей" onClick={dispatch.nextTeam} />
            </div>

            {selectedTeam && (
                <TeamRuntimeModal
                    key={selectedTeam.teamId || selectedTeam.id}
                    team={selectedTeam}
                    democracyId={democracy.id}
                    onClose={() => setSelectedTeam(null)}
                />
            )}
        </div>
    );
}

TeamsColumn.propTypes = {
    session: PropTypes.object.isRequired,
    democracy: PropTypes.object.isRequired,
    dispatch: PropTypes.object.isRequired
};
